// extracted by extract-css-chunks-webpack-plugin
module.exports = {"why":"Lm0dbVsPYnHuSOrU90Uu","why-header":"BF_larkG2NyUjSvANmZS","reasons":"CsoCVf49VCL4CLUenUJL","reason":"V_zRoSwXu8qswWRHNq9D"};